'use client';

import { useState } from 'react';
import LanguageSelector from '@ui/components/ui/language-selector';
import { Locale } from '@ui/lib/locale';
import { useLocale } from 'next-intl';
import { setLocale } from '@/i18n/request';
import LocaleDetector from './locale-detector';

export default function LanguageClient() {
  const [language, setLanguage] = useState<Locale>(useLocale() as Locale);

  return (
    <>
      <LocaleDetector setLanguage={(locale) => setLanguage(locale)} />
      <LanguageSelector
        onValueChange={(language) => {
          setLanguage(language);
          setLocale(language);
        }}
        value={language}
        variant="full"
      />
    </>
  );
}
